import { CONTACT } from '@/config/site';

const WA_BASE = `https://wa.me/${CONTACT.whatsappNumber}`;

/**
 * Builds a wa.me deep link with a pre-filled message.
 *
 * Every WhatsApp entry point on the site goes through here so conversations
 * always start with context — the single biggest conversion lever in the
 * WhatsApp-first model this store runs on.
 */
export function whatsappLink(message?: string): string {
  if (!message) return WA_BASE;
  return `${WA_BASE}?text=${encodeURIComponent(message)}`;
}

/** Canonical, reusable openers. Product and cart messages are built at call time. */
export const WA_MESSAGES = {
  general: 'Olá! Vim pelo site da BrucePets e quero consultar opções de rações.',
  dogs: 'Olá! Vim pelo site da BrucePets. Quero consultar rações para cães.',
  cats: 'Olá! Vim pelo site da BrucePets. Quero consultar rações para gatos.',
  premium: 'Olá! Vim pelo site da BrucePets. Quero consultar rações premium e super premium.',
  brandRequest:
    'Olá! Vim pelo site da BrucePets. Não encontrei uma marca no site e queria saber se vocês trabalham com ela.',
  help: 'Olá! Vim pelo site da BrucePets e preciso de ajuda para escolher a ração certa para o meu pet.',
} as const;

/** Ready-to-use links for the static openers above. */
export const WA_LINKS = {
  general: whatsappLink(WA_MESSAGES.general),
  dogs: whatsappLink(WA_MESSAGES.dogs),
  cats: whatsappLink(WA_MESSAGES.cats),
  premium: whatsappLink(WA_MESSAGES.premium),
  brandRequest: whatsappLink(WA_MESSAGES.brandRequest),
  help: whatsappLink(WA_MESSAGES.help),
} as const;

export function productEnquiryMessage(productName: string, variantLabel?: string): string {
  const item = variantLabel ? `${productName} — ${variantLabel}` : productName;
  return `Olá! Tenho interesse neste produto: ${item}. Pode me informar disponibilidade, valor e entrega?`;
}

export function productEnquiryLink(productName: string, variantLabel?: string): string {
  return whatsappLink(productEnquiryMessage(productName, variantLabel));
}
